module.exports = __webpack_public_path__ + "static/media/loading.2289b0fe.svg";